<script>
import logo from '@/assets/images/logo.png'
export default {
  data: function () {
    return {
      logo,
      serviceProvider: window.serviceProvider
    }
  }
}
</script>

<template lang="pug">
span
  img.custom-logo(
    :alt="serviceProvider.name"
    :src="serviceProvider.logo"
    v-if="!!serviceProvider && serviceProvider.logo.indexOf('serviceProviderLogoToReplac') != 0"
  )
  img(alt="Collectomate logo 1" :src="logo" v-else)
</template>

<style scoped lang="scss">
img {
  max-width: calc(100vw - 4rem);
  height: auto;

  @media (min-width: 992px) {
    margin-top: -2rem;
    height: 20vh;
  }
}
</style>
